import { render, staticRenderFns } from "./ItemTblDatasourceComponent.vue?vue&type=template&id=584fed05"
import script from "./ItemTblDatasourceComponent.vue?vue&type=script&lang=js"
export * from "./ItemTblDatasourceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584fed05')) {
      api.createRecord('584fed05', component.options)
    } else {
      api.reload('584fed05', component.options)
    }
    module.hot.accept("./ItemTblDatasourceComponent.vue?vue&type=template&id=584fed05", function () {
      api.rerender('584fed05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/principal_search/components/ItemTblDatasourceComponent.vue"
export default component.exports